import { createAction, props } from '@ngrx/store';

export const loadChats = createAction(
  '[Chat] Load Chats'
);

export const UpdateChatStatus = createAction(
  '[Chat] Update Chat Status',
  props<{ status: string }>()
);

export const SendChatMessage = createAction(
  '[Chat] Send Chat Status',
  props<{ payload: any }>()
);

export const SendChatMessageSuccess = createAction(
  '[Chat] Send Chat Status Success',
  props<{ data: any }>()
);

export const SendChatMessageFailure = createAction(
  '[Chat] Send Chat Status Failure',
  props<{ error: any }>()
);

export const WSDeleteChatMessage = createAction(
  '[Chat] WS Delete Chat Message',
  props<{ payload: any }>()
);

export const DeleteChatMessage = createAction(
  '[Chat] Delete Chat Message',
  props<{ payload: any }>()
);

export const DeleteChatMessageSuccess = createAction(
  '[Chat] Delete Chat Message Success',
  props<{ data: any }>()
);

export const DeleteChatMessageFailure = createAction(
  '[Chat] Delete Chat Message Failure',
  props<{ error: any }>()
);

export const UnblockChatAttendee = createAction(
  '[Chat] Unblock Chat Attendee',
  props<{ payload: any }>()
);

export const UnblockChatAttendeeSuccess = createAction(
  '[Chat] Unblock Chat Attendee Success',
  props<{ data: any }>()
);

export const UnblockChatAttendeeFailure = createAction(
  '[Chat] Unblock Chat Attendee Failure',
  props<{ error: any }>()
);

export const AddChatMessage = createAction(
  '[Chat] Add Chat Message',
  props<{ payload: any }>()
);
